var map = {
	"./1.png": 2009,
	"./10.png": 784,
	"./11.png": 358,
	"./12.png": 1770,
	"./2.png": 4962,
	"./3.png": 4201,
	"./4.png": 4910,
	"./5.png": 5983,
	"./7.png": 8668,
	"./8.png": 869,
	"./9.png": 1172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7946;